import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { Routes, RouterModule } from '@angular/router';
import { WebsocketService } from "./services/websocket.service";
import { CborDataDecorator } from "./core/app.core.cbor";
import { EventRunner } from './core/app.core.events';
import { ModalComponent } from './modal/modal.component';
import { ArrayAssociative } from "./core/array.core.data";
import { DynamicComponentLoaderService } from './services/dynamic-component-loader.service';
import { ModalService } from './services/modal.service';
import '@ungap/custom-elements';
import 'aframe';
import '@angular/material';


const cbor = require('cbor-web');
@Component({
	selector: 'neverume',
	templateUrl: './neverume.component.html',
	styleUrls: ['./neverume.component.scss'],
	providers: [DynamicComponentLoaderService, CborDataDecorator],
	standalone: false
	
})

export class NeverumeComponent {

	el: any;
	animateCircle = false;
	showScene = false;
	sceneHeight = 'auto'; // Сброс высоты при уходе курсора
	sceneTop = '0';
	isHovered = false;
	sent = new Array();

	constructor(private websocketService: WebsocketService, public eventRunner: EventRunner, private cdd: CborDataDecorator) {
		let e = this.eventRunner;
		this.websocketService.messages.subscribe(msg => {
			let m = this.cdd.decode(msg).then(data => e.listner(data));
		});
	}
	
	onInit() {
		document.querySelector('a-scene').addEventListener('loaded', function () {
	     // this.camera.el.setAttribute('camera', 'active: false')
	    })
	}


	handleMouseMove(event: Event): void {
		const mouseEvent = event as MouseEvent;
		if (this.showScene != true) {

			const circle = document.querySelector('.circle-wrapper') as HTMLElement;
			const rect = circle.getBoundingClientRect();
			const circleRadius = rect.width / 2;
			const distance = Math.sqrt(
				Math.pow(mouseEvent.clientX - (rect.left + circleRadius), 2) +
				Math.pow(mouseEvent.clientY - (rect.top + circleRadius), 2)
			);

			if (distance < circleRadius) {
				this.animateCircle = true;
				setTimeout(() => {
					this.showScene = true;
				}, 1000); // Задержка для завершения анимации круга
			} else {
				this.animateCircle = false;
				this.showScene = false;
			}
		}
	}

	handleMouseLeave(): void {
		if (this.animateCircle != true) {
			this.animateCircle = false;
			this.showScene = false;
		}
	}

	sendMsg(message: ArrayAssociative) {
		//slet cborm = cdd.encode(message);
		//this.sent.push(cborm);//cdd.encode(cborm);
		this.websocketService.sendws(message);
	}


	onMouseMove(event: Event): void {

		const mouseEvent = event as MouseEvent;
		if (this.showScene == true) {
			// Изменение высоты и позиции top сцены в зависимости от положения курсора по ширине
			const windowWidth = window.innerWidth;
			const cursorX = mouseEvent.clientX;
			// Изменение позиции top сцены в зависимости от вертикального положения курсора
			const windowHeight = window.innerHeight;
			const cursorY = mouseEvent.clientY;
			const navWrapper = document.querySelector('.nav-wrapper') as HTMLElement;
			
			const h = navWrapper.getBoundingClientRect().height;
			const ar = h / windowHeight;
			if ((cursorX / windowWidth) < ar) {
				this.sceneTop = '-30vh';
				this.sceneHeight = navWrapper.getBoundingClientRect().height.toString() + 'px';
			} else if ((cursorX / windowWidth) > 0.7) {
				this.sceneHeight = '100vh';
				this.sceneTop = '0vh';
			} else {
				this.sceneHeight = `${(cursorX / windowWidth) * 100 / 0.7}vh`;
				this.sceneTop = `${-30 + ((cursorX / windowWidth) * 30 / 0.7)}vh`;
			}
			this.isHovered = true;

			const c = document.querySelector(".camera") as any;

			
			console.log(c.object3D);
				if (c.className === 'camera') {
					c.removeAttribute('camera', 'active', 'true');
					c.setAttribute('camera', 'active', 'true');
					console.log(c);
				} else {
					c.removeAttribute('camera', 'active', 'false');
					c.setAttribute('camera', 'active', 'false');
				}
			


			const rotationY = (cursorX / windowWidth) * 360 * 4;  // Поворот вокруг оси Y
			const rotationX = (cursorY / windowHeight) * -20 + 10;  // Поворот вокруг оси X от -45 до 45 градусов

			if (c && c.object3D) {//AFRAME.THREE.MathUtils.degToRad(rotationX),

				console.log(c.object3D);
				c.object3D.rotation.set(
					AFRAME.THREE.MathUtils.degToRad(rotationX),
					AFRAME.THREE.MathUtils.degToRad(rotationY),
					0  // Поворот вокруг оси Z остается 0
				);
			}
			console.log(c.object3D.rotation);
		}
	}
	onMouseLeave(): void {
		this.sceneTop = '-30vh'
		this.sceneHeight = 'auto';
		this.isHovered = false;
		this.showScene = false;
		this.animateCircle = false;
		this.showScene = false;
	}

	rotartion() {
		/*//
		<mat-toolbar [style.backgroundColor]="'transparent'">
		<button mat-icon-button [matMenuTriggerFor]="menu"
			aria-label="Example icon-button with a menu">
			<mat-icon>pages</mat-icon>
		</button>
		<mat-menu #menu="matMenu"> <a mat-menu-item
			routerLink="/profile/avatarmaker"><mat-icon>view_day</mat-icon><span>Avatar</span></a>
		<a mat-menu-item routerLink="/profile/photobook"><mat-icon>landscape</mat-icon><span>Photo</span></a>
		<a mat-menu-item routerLink="/profile/audiobook"><mat-icon>blur_linear</mat-icon><span>Audio</span></a><!-- headset -->
		<a mat-menu-item routerLink="/auth/postauth"><mat-icon>face</mat-icon><span>Nick</span></a><!-- -->
		<a mat-menu-item routerLink="/stream/accounts"><mat-icon>movie</mat-icon><span>Stream</span></a>
		<a mat-menu-item routerLink="/video/"><mat-icon>movie_filter</mat-icon><span>Video</span></a>
		<a mat-menu-item routerLink="/profile/photostorage"><mat-icon>party_mode</mat-icon><span>Photo
				Storage</span></a>
		<a mat-menu-item routerLink="/discourse"><mat-icon>grain</mat-icon><span>Discourse</span></a>
		<a mat-menu-item routerLink="/profile"><mat-icon>3d_rotation</mat-icon><span>Shifts</span></a>
		<a mat-menu-item routerLink="/dockets"><mat-icon>dashboard</mat-icon><span>Dockets</span></a>
		<a mat-menu-item routerLink="/profile/accounts"><mat-icon>recent_actors</mat-icon><span>Accounts</span></a><!-- supervisor_account -->
		<a mat-menu-item routerLink="/application/confiditialpolicy"><mat-icon>aspect_ratio</mat-icon><span>Confidential
				Policy</span></a> <a mat-menu-item
			routerLink="/application/visitoragreements"><mat-icon>security</mat-icon><span>Visitor
				Agreements</span></a> </mat-menu> </mat-toolbar>
		С помощью Three.js
		 el.object3D.rotation.set( 
		  THREE.MathUtils.degToRad( 15 ), 
		  THREE.MathUtils.degToRad( 30 ), 
		  THREE.MathUtils.degToRad( 90 ) 
		); 
		el.object3D.rotation.x += Math .PI;

		// С .setAttribute (менее рекомендуется).
		 el.setAttribute( 'rotation' , { x : 15 , y : 30 , z : 90 });*/
	}
}